$(document).ready(function(){
  setTimeout(function(){
      $('.custom-banner-slider .product-slider').slick({
        infinite:true,
        // slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 7500,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        dots:false,
        variableWidth: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1920,
            settings: {
              // centerPadding: '60px',
              slidesToShow: 8,
            }
          },
          {
            breakpoint: 1601,
            settings: {
              // centerPadding: '60px',
              slidesToShow: 7,
            }
          },
          {
            breakpoint: 1199,
            settings: {
              // centerPadding: '60px',
              slidesToShow: 6,
            }
          },
          {
            breakpoint: 991,
            settings: {
              // centerPadding: '40px',
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 750,
            settings: {
              centerMode: true,
              slidesToShow: 3,
              centerPadding: '0px',
            }
          }
        ]
      });
  }, 100);
});
